import apiPayment from "./dueChargesApi";
import {
  dueChargesLoaded,
  dueChargesLoading,
  failed,
  moreDueChargesLoaded,
  moreDueChargesLoading,
  moreStatementInformationLoaded,
  moreStatementInformationLoading,
  statementInformationLoaded,
  statementInformationLoading,
} from "./dueChargesStateActions";

export function loadDueCharges(dispatch: any, customerAccountId: number, pageSize: number, pageIndex: number) {
  dispatch(dueChargesLoading());
  apiPayment.getBillingCycles(customerAccountId, pageIndex, pageSize, true).then(
    (charges: any) => dispatch(dueChargesLoaded(charges, pageIndex)),
    function (error: any) {
      return dispatch(failed());
    }
  );
}

export function loadMoreDueCharges(dispatch: any, customerAccountId: number, pageSize: number, pageIndex: number) {
  dispatch(moreDueChargesLoading());
  apiPayment.getBillingCycles(customerAccountId, pageIndex, pageSize, true).then(
    (charges: any) => dispatch(moreDueChargesLoaded(charges, pageIndex)),
    function (error: any) {
      return dispatch(failed());
    }
  );
}

export function loadStatementInformation(
  dispatch: any,
  customerAccountId: number,
  pageSize: number,
  pageIndex: number
) {
  dispatch(statementInformationLoading());
  apiPayment.getHistoryBillingCycleDetails(customerAccountId, pageIndex, pageSize).then(
    (charges: any) => dispatch(statementInformationLoaded(charges, pageIndex)),
    function (error: any) {
      return dispatch(failed());
    }
  );
}

export function loadMoreStatementInformation(
  dispatch: any,
  customerAccountId: number,
  pageSize: number,
  pageIndex: number
) {
  dispatch(moreStatementInformationLoading());
  apiPayment.getHistoryBillingCycleDetails(customerAccountId, pageIndex, pageSize).then(
    (charges: any) => dispatch(moreStatementInformationLoaded(charges, pageIndex)),
    function (error: any) {
      return dispatch(failed());
    }
  );
}
